// extracted by mini-css-extract-plugin
export default {"textAreaBlock":"textArea_textAreaBlock__LPMMi","label":"textArea_label__XHhwF","textArea":"textArea_textArea__0uHlr","labelTop":"textArea_labelTop__LXEj-"};